import React  from 'react';
import {withRouter} from "react-router-dom"
import { TitleXl } from "components/elements";
import {OtherNewsLettersWrapper, TitleXlContainer, NewsLetterContainer} from './elements';
import Newsletters from 'components/Newsletters';



function LearnAboutOtherNewsletters({monthly, valueReport, rdv, healthEquity, displayHeader}) {

    return(
        <OtherNewsLettersWrapper>
            {displayHeader && (
            <TitleXlContainer>
                <TitleXl color="#000" fontWeight="900">Learn more about our other newsletters</TitleXl>
            </TitleXlContainer>
            )}
       
            <NewsLetterContainer>
                {monthly && (
                    <Newsletters title={"The Healthcare Connection"} intro={"A monthly roundup of the people, stories and ideas that are changing healthcare for the better."} image={"/images/Healthcare_Connection_Thumb.png"} link="/healthcare-connection" width="48%"/>
                )}
                {healthEquity && (
                    <Newsletters title={"Health Equity Digest"} intro={"Insights, education and analytics at the intersection of public health and health equity. Delivered once a month."} image={"/images/Health_Equity_thumb.png"}  link="/health-equity-digest" width="48%"/>
                )}
                  {valueReport && (
                    <Newsletters title={"Weekly Value Report"} intro={"A weekly round-up and analysis of biopharma pricing and value news."} image={"/images/Value_Report_Thumb.png"}  link="/weekly-value-newsletter" width="48%"/>
                )}
              
            </NewsLetterContainer>
        </OtherNewsLettersWrapper>
    )
}

export default withRouter(LearnAboutOtherNewsletters);
